import React from "react";

export default function JS_This() {
  return (
    <div className="tutorial-container">
      <h1>JS This</h1>
      <p>This tutorial explains the concept of JS This in JavaScript OOPs.</p>
    </div>
  );
}
